import React from 'react';

import { Action } from 'state';
import Field from 'types/Field';
import Section from 'types/Section';
import TextFieldPreview from './TextFieldPreview';

interface NumericFieldPreview {
  field: Field;
  section: Section;
  dispatch: (action: Action) => void;
}

const NumericFieldPreview: React.FC<NumericFieldPreview> = ({ section, field, dispatch }) => {
  return <TextFieldPreview section={section} field={field} dispatch={dispatch} numeric unit={field.measurement_unit} />;
};

export default NumericFieldPreview;
